import axios from "axios";

const getQA = async (lang: string) => {
  return await axios.get(`${process.env.REACT_APP_BACKEND_HOST}/${lang}/qa`);
};

export default getQA;
